import * as React from 'react';
import s from '../solution-page-views/solution-overview/solution-overview.scss';
import { PreviewMode } from '../preview-elements/preview-context';
import Add from 'wix-ui-icons-common/Add';
import { composer } from '../../../component-decorators/composer';
import { Divider, TextButton, Box } from 'wix-style-react';
export var DemoLinkPreviewWrapper = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(PreviewMode.Consumer, null, function (value) {
        return value.isPreview && !props.src ? (React.createElement("div", null,
            React.createElement("div", { className: s.linkDivider },
                React.createElement(Divider, null)),
            React.createElement(Box, { marginTop: 3 },
                React.createElement(TextButton, { prefixIcon: React.createElement(Add, null), as: "a", href: "https://dev.wix.com/dc3/my-apps/" + value.appId + "/market/info/basic-info", target: "_blank" }, props.t('solution.page.preview.addDemoCta'))))) : (props.children);
    }));
});
//# sourceMappingURL=demo-link-wrapper.js.map